import { apiConfig } from '@/services/api-config';

export default async function getTerritoryImgByCar(geom: string): Promise<string | ''> {
  const tmxToken = sessionStorage.getItem('chave');
  const userLogged = sessionStorage.getItem('userLogged');
  if (!userLogged) {
    return '';
  }

  const payload = { wkt: geom };

  const uri = 'api/territory/image';
  try {
    const response = await apiConfig.post(uri, payload, {
      headers: {
        Authorization: tmxToken,
      },
    });
    return response.data.objectResult;
  } catch (error) {
    return '';
  }
}
